<script>
import { supplierService } from "../../../helpers/backend/supplier.service"

export default {
  data() {
    return {
      form: {
        id: null,
        name: "",
        address: "",
        email: "",
        phone_number: "",
        npwp: "",
      },
      busy: false,
      show: true,
      showDismissibleAlert: false,
      error: "",
      active: false,
    }
  },
  computed: {
    isUpdateState() {
      return this.form.id != null
    },
  },
  methods: {
    onSubmit(event) {
      event.preventDefault()
      this.busy = true
      supplierService.save(this.form).then(
        (data) => {
          if (data != null) {
            this.reset()
            this.$emit("refresh")
            this.showDismissibleAlert = true
            this.error = ""
            this.setActive(false)
          }
          this.busy = false
        },
        (error) => {
          this.showDismissibleAlert = true
          this.error =
            "Failed to Insert/Update Principle Type. Error : " + error
          this.busy = false
        }
      )
    },
    reset() {
      // Reset our form values
      this.form.id = null
      this.form.name = ""
      this.form.address = ""
      this.form.email = ""
      this.form.phone_number = ""
      this.form.npwp = ""
      // Trick to reset/clear native browser form validation state
      this.show = false
      this.showDismissibleAlert = false
      this.error = ""
      this.$nextTick(() => {
        this.show = true
      })
    },
    onReset(event) {
      event.preventDefault()
      this.setActive(false)
      this.reset()
    },
    setActive(b, outside_triger) {
      this.active = b
      if (outside_triger) return
      this.$emit("active_change", b)
    },
    initUpdate(id) {
      this.setActive(true)

      this.$nextTick(() => {
        this.reset()
        this.$refs.name.$el.focus()
        this.busy = true
        supplierService.fetch(id).then(
          (data) => {
            if (data.supplier != null) {
              this.form.id = data.supplier.id
              this.form.name = data.supplier.name
              this.form.address = data.supplier.address
              this.form.email = data.supplier.email
              this.form.phone_number = data.supplier.phone_number
              this.form.npwp = data.supplier.npwp
            } else {
              this.showDismissibleAlert = true
              this.error =
                "Failed to get supplier type to update. Error : supplier not found"
            }
            this.busy = false
          },
          (err) => {
            this.showDismissibleAlert = true
            this.error =
              "Failed to get supplier type to update. Error : " + err
            this.busy = false
          }
        )
      })
    },
    invokeCreate() {
      this.setActive(true)
    },
  },
}
</script>

<template>
  <div v-if="this.active">
    <b-alert
      :variant="error == '' ? 'success' : 'danger'"
      dismissible
      fade
      :show="showDismissibleAlert"
      @dismissed="showDismissibleAlert = false"
    >
      <div v-if="error != ''">
        {{ error }}
      </div>
      <div v-else>Success perform Insert/Update action</div>
    </b-alert>
    <div class="card">
      <div class="card-body">
        <div>
          <b-form @submit="onSubmit" @reset="onReset" v-if="show" ref="form">
            <b-overlay :show="busy" rounded="lg" opacity="0.6">
              <b-form-group
                id="input-group-name"
                label="Supplier Name:"
                label-for="input-name"
              >
                <b-form-input
                  id="input-name"
                  v-model="form.name"
                  type="text"
                  placeholder="Supplier Name"
                  required
                  ref="name"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-address"
                label="Address :"
                label-for="input-address"
              >
                <b-form-input
                  id="input-address"
                  v-model="form.address"
                  type="text"
                  placeholder="Supplier Address"
                  required
                  ref="address"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-email"
                label="Contact Email :"
                label-for="input-email"
              >
                <b-form-input
                  id="input-email"
                  v-model="form.email"
                  type="text"
                  placeholder="Contact Email"
                  required
                  ref="email"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-phone-number"
                label="Contact Number :"
                label-for="input-phone-number"
              >
                <b-form-input
                  id="input-phone-number"
                  v-model="form.phone_number"
                  type="text"
                  placeholder="Phone Number"
                  required
                  ref="phone-number"
                ></b-form-input>
              </b-form-group>

              <b-form-group
                id="input-group-npwp"
                label="Supplier NPWP :"
                label-for="input-npwp"
              >
                <b-form-input
                  id="input-npwp"
                  v-model="form.npwp"
                  type="text"
                  placeholder="NPWP"
                  required
                  ref="npwp"
                ></b-form-input>
              </b-form-group>

              <b-button class="mr-2" type="submit" variant="primary">
                {{ isUpdateState ? "Update" : "Submit" }}
              </b-button>
              <b-button type="reset" variant="danger">Cancel</b-button>
            </b-overlay>
          </b-form>
        </div>
      </div>
    </div>
  </div>
  <div v-else>
    <b-form-group>
      <b-button variant="primary" @click="invokeCreate">Create new</b-button>
    </b-form-group>
  </div>
</template>



